var _defs, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTotalPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.664,
    height: 39.333,
    viewBox: "0 0 34.664 39.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f9f8f9;}.b{fill:#e3e0e4;}.c{fill:#dc4955;}.d{fill:#c42430;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M83.966,35.821a3.515,3.515,0,0,1-3.519,3.512H56.254a3.515,3.515,0,0,1-3.519-3.512V3.512A3.515,3.515,0,0,1,56.254,0H71.315a2.642,2.642,0,0,1,1.868.773L83.195,10.787a2.631,2.631,0,0,1,.771,1.86Z",
    transform: "translate(-51.018 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M58.628,39.333H56.254a3.516,3.516,0,0,1-3.519-3.512V3.512A3.516,3.516,0,0,1,56.254,0h2.374a3.516,3.516,0,0,0-3.519,3.512V35.821A3.516,3.516,0,0,0,58.628,39.333Z",
    transform: "translate(-51.018 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M291.863,12.647v1.285h-9.177a4.759,4.759,0,0,1-4.753-4.754V0h1.28a2.643,2.643,0,0,1,1.868.773l10.012,10.013A2.631,2.631,0,0,1,291.863,12.647Z",
    transform: "translate(-258.915 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M320.158,14.421h-8.941a2.379,2.379,0,0,1-2.379-2.38V3.1a2.614,2.614,0,0,1,.773.535l10.012,10.013a2.614,2.614,0,0,1,.534.772Z",
    transform: "translate(-287.447 -2.863)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M61.889,229.073H33.557a3.166,3.166,0,0,1-3.166-3.166V214.353a3.166,3.166,0,0,1,3.166-3.166H61.889a3.166,3.166,0,0,1,3.166,3.166v11.555A3.166,3.166,0,0,1,61.889,229.073Z",
    transform: "translate(-30.391 -194.963)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M35.535,229.073H33.557a3.166,3.166,0,0,1-3.166-3.166V214.353a3.166,3.166,0,0,1,3.166-3.166h1.979a3.166,3.166,0,0,0-3.166,3.166v11.555A3.166,3.166,0,0,0,35.535,229.073Z",
    transform: "translate(-30.391 -194.963)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.47 20.096)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M337.322,262.772a.594.594,0,0,0,0-1.187h-3.63a.593.593,0,0,0-.594.594v8.956a.594.594,0,1,0,1.187,0v-3.969h2.748a.594.594,0,0,0,0-1.187h-2.748v-3.206Z",
    transform: "translate(-324.314 -261.585)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M221.818,262.891h-2.48a.594.594,0,0,0-.594.595v.008h0v8.6a.588.588,0,0,0,.018.142v0a.594.594,0,0,0,.594.591h0c.075,0,1.839-.007,2.543-.019a3.786,3.786,0,0,0,2.989-1.521,5.65,5.65,0,0,0,1.057-3.431C225.947,264.889,224.288,262.891,221.818,262.891Zm.062,8.736c-.442.008-1.335.013-1.933.016,0-.979-.009-2.91-.009-3.791,0-.736,0-2.76-.005-3.774h1.885c2.169,0,2.942,1.954,2.942,3.784C224.76,270.049,223.576,271.6,221.88,271.627Z",
    transform: "translate(-218.745 -262.791)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M109.345,261.444h-2.533c-.518,0-.546.226-.546.545v9.1a.545.545,0,0,0,1.091,0v-3.408c.591,0,1.53-.008,1.987-.008a3.113,3.113,0,1,0,0-6.224Zm0,5.134c-.454,0-1.379,0-1.973.008,0-.608-.008-1.566-.008-2.03,0-.389,0-1.39,0-2.021h1.986a2.022,2.022,0,1,1,0,4.043Z",
    transform: "translate(-100.438 -241.359)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalPdf);
export default __webpack_public_path__ + "static/media/total-pdf.2b7bc75bb3635398c140694abc551367.svg";
export { ForwardRef as ReactComponent };